// import {
//     NOTIFICATION_GET_DETAILS
// } from "../actions"
//
// export const getNotificationDetail = (data) => ({
//     type: NOTIFICATION_GET_DETAILS,
//     payload: data,
// });

import {
    NOTIFICATION_GET_DETAILS
} from "../actions"

export const getNotificationDetail = (data) => ({
    type: NOTIFICATION_GET_DETAILS,
    payload: data,
});

